import { Inject } from 'inversify-props'
import { CanalVendaMarketplace, Page } from '@/models'
import { AxiosRequestConfig } from 'axios'
import type { MarketplaceServiceAdapter } from './adapter'

export class FindCanalDeVendaMarketplaceUseCase {
	@Inject('MarketplaceServiceAdapter')
	private marketplaceAdapter!: MarketplaceServiceAdapter

	findAll = async (params: any, config?: AxiosRequestConfig): Promise<Page<CanalVendaMarketplace>> =>
		this.marketplaceAdapter.findAllCanaisDeVenda(params, config)

}